import { all, fork } from 'redux-saga/effects';
import { sagas } from '@wix/da-shared-react/pkg/redux/shared';
import streamsSaga from './streams';
import studioSaga from './studio';
import stashSaga from './stash';

export default function* rootSaga() {
  yield all(sagas.map(fork));
}

export function* studioRootSaga() {
  yield all([fork(streamsSaga), fork(studioSaga), fork(stashSaga), ...sagas.map(fork)]);
}
